import {
  getDetailIndex as getDetailIndexCommon,
  getDetailIndexCombine as getDetailIndexCombineOriginal,
  // getDetailIndexRank as getDetailIndexRankCommon,
  getDetailIndexRankCombine as getDetailIndexRankCombineOriginal,
  getSingleGameDetail as getSingleGameDetailCommon,
  getSingleGameDetailMobile as getGameDetailMobile,
} from '@intelligence/services/topcharts';
import {
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  MObile_ENTITY_TYPE,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { toDateTypeLy, toDateTypeNor } from '@intelligence/utils/common';
import { COMBINEID_REG } from '@intelligence/utils/constant';
import type { IGameType } from '@intelligence/types/common';
// import type { IReleaseDateByPlatformRes } from '@intelligence/pages/TopCharts/components/DetailsPage/ReleaseDateByPlatform/types';
import type { IDownloadableContent } from '@intelligence/pages/TopCharts/components/DetailsPage/DownloadableContent';

const handleCombineCommonParams = (payload: any): any => {
  if (!payload) return {};
  const payloadTmp = {
    ...payload,
    id: payload?.unified_id || '',
    date_type: toDateTypeLy[payload?.date_type] || '',
  };
  delete payloadTmp.unified_id;
  return payloadTmp;
};

const handleCombineCommonRes = (res: any): any => {
  if (!res) return {};
  const req = res?.req || {};
  const reqDateType = req?.date_type || 'daily';
  return {
    ...res,
    req: {
      ...req,
      date_type: toDateTypeNor[reqDateType] || '',
    },
  };
};

const parseReleaseDateByPlatformsJson = (json: string) => {
  if (!json) return [];
  try {
    return JSON.parse(json);
  } catch (e) {
    return [];
  }
};

// const parseReleaseDateByPlatformsRes = (
//   jsonStr: string,
// ): IReleaseDateByPlatformRes[] => {
//   let releaseDateByPlatforms: IReleaseDateByPlatformRes[] = [];
//   try {
//     const dataTmp = JSON.parse(jsonStr);
//     // 兼容数据格式，处理多维数组展示 Early Access 和 Full Release时间，数据格式如下，其他情况按原逻辑
//     /** [
//         {
//           platform: 'PC (Microsoft Windows)',
//           releaseDates: [
//             {
//               country: 'Worldwide [WW]',
//               firstReleaseDate: '2022-5-17',
//               releases: [
//                 { date: '2022-5-17', label: 'Early Access' },
//                 { date: '2024-5-8', label: 'Full Release' },
//               ],
//             },
//           ],
//         },
//         {
//           platform: 'PlayStation 5',
//           releaseDates: [
//             {
//               country: 'Worldwide [WW]',
//               firstReleaseDate: '2024',
//               releases: [{ date: '2024', label: null }],
//             },
//           ],
//         },
//       ]; **/
//     if (Array.isArray(dataTmp)) {
//       releaseDateByPlatforms = dataTmp.map((item) => {
//         // 顶级releaseDate
//         const general = item.releaseDates[0];
//         const release_date: any = [];

//         // 正则处理general的country标识码，原逻辑是用国际标识码处理后续展示，这里切割出[]里的识别码
//         let pattern = /\[([^\]]*)\]/;
//         let match = general?.country?.match(pattern) || null;
//         let matchResult = null;
//         if (match) {
//           // 移除匹配结果中的中括号
//           matchResult = match[0].slice(1, -1);
//         }
//         // 把release_date处理成二维数组
//         release_date.push([
//           matchResult || general.country,
//           general.firstReleaseDate,
//         ]);
//         const releases = general?.releases;
//         if (releases && Array.isArray(releases)) {
//           releases.forEach((i) => {
//             const labelKey: string = i?.label;
//             labelKey &&
//               release_date?.push([labelKey, i.date?.replace(/'/g, '"')]);
//           });
//         }
//         return {
//           platform: item.platform,
//           release_date,
//         };
//       });
//     } else {
//       Object.keys(dataTmp).forEach((key) => {
//         try {
//           let releaseDate = JSON.parse(dataTmp[key].replace(/'/g, '"'));
//           releaseDateByPlatforms.push({
//             platform: key,
//             release_date: releaseDate,
//           });
//         } catch (exception) {}
//       });
//     }
//   } catch (exception) {}
//   return releaseDateByPlatforms;
// };

const parseDownloadContentsRes = (
  jsonStr: string,
): {
  [key: string]: IDownloadableContent[];
} => {
  const downloadContents: {
    [key: string]: IDownloadableContent[];
  } = {};
  try {
    const downloadContentsTmp = JSON.parse(jsonStr);
    Object.keys(downloadContentsTmp).forEach((key) => {
      const downloadContentTmp = downloadContentsTmp[key]?.map((item: any) => ({
        name: item?.content_name || '',
        image: item?.content_img || '',
        time: '',
      }));
      downloadContents[key] = downloadContentTmp || [];
    });
  } catch (exception) {}
  return downloadContents;
};

const getDetailIndexCombine = async (payload: any): Promise<any> => {
  const payloadTmp = handleCombineCommonParams(payload);
  const res = await getDetailIndexCombineOriginal(payloadTmp);
  return handleCombineCommonRes(res);
};

const getDetailIndexRankCombine = async (payload: any): Promise<any> => {
  const payloadTmp = handleCombineCommonParams(payload);
  const res = await getDetailIndexRankCombineOriginal(payloadTmp);
  return handleCombineCommonRes(res);
};

const getSingleGameDetailCombine = async (payload: any): Promise<any> => {
  const { basic_info_others: basicInfoOthers } = payload || {};
  const {
    description,
    download_content: downloadContent,
    release_dates_by_platform: releaseDatesByPlatform,
    similar_apps: similarGames,
    image,
    images,
    video,
    video_screen: videoScreen,
  } = basicInfoOthers || {};
  const resData = {
    description,
    download_content: parseDownloadContentsRes(downloadContent),
    // release_dates_by_platform: parseReleaseDateByPlatformsRes(releaseDatesByPlatform),
    release_dates_by_platform: parseReleaseDateByPlatformsJson(releaseDatesByPlatform),
    image,
    images,
    similar_games: similarGames,
    video,
    video_screen: videoScreen,
    // 仅mobile需要用，pc、console没有，所以固定返回空数组
    timelines: [],
  };
  return Promise.resolve({
    code: 0,
    req: {},
    msg: 'ok',
    data: resData,
  });
};

export const createDetailIndexFetcher = (
  entityType: IGameType,
): ((payload: any) => Promise<any>) => {
  if (entityType === MObile_ENTITY_TYPE) return getDetailIndexCommon;
  return getDetailIndexCombine;
};

export const createDetailIndexRankFetcher = (): // entityType: IGameType,
((payload: any) => Promise<any>) =>
  // if (entityType === MObile_ENTITY_TYPE) return getDetailIndexRankCommon;
  getDetailIndexRankCombine;

export const createSingleGameDetailFetcher = (
  entityType: IGameType,
): ((payload: any) => Promise<any>) => {
  // combine，需要从base_info里获取
  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) return getSingleGameDetailCombine;

  // pc、console 调用原about接口
  return async (subPayload: any) => {
    const subPayloadTmp = { ...subPayload };
    delete subPayloadTmp.basic_info_others;
    // 添加游戏ID校验规则
    if (COMBINEID_REG.test(subPayloadTmp?.unified_id)) {
      let res = await (entityType === MObile_ENTITY_TYPE
        ? getGameDetailMobile(subPayloadTmp)
        : getSingleGameDetailCommon(subPayloadTmp));
      if (res?.data) {
        // 需要把原接口 mobile、pc、console返回的 download_content 加一层分类（固定为all），从数据结构上跟pcConsole联合游戏详情页 保持一致
        const downloadContents = res?.data?.download_content || [];
        res = {
          ...res,
          data: {
            ...res?.data,
            download_content: {
              all: downloadContents,
            },
          },
        };
      }
      return res;
    }
    return {};
  };
};
